import { render } from "./AdminAutomations.vue?vue&type=template&id=b9efc244"
import script from "./AdminAutomations.vue?vue&type=script&lang=js"
export * from "./AdminAutomations.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__